export interface Media {
  images: string[];
  videos: string[];
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export interface Prize {
  giftId: any; // Can be populated with Gift object or just ID
  status:
    | "approved"
    | "pending"
    | "rejected"
    | "auto-approved"
    | "self-approved";
  _id?: string;
}

export interface Analytics {
  totalWinners: number;
  totalParticipants: number;
  winners: string[];
  participants: string[];
}

export interface LuckyDraw {
  _id: string;
  name: string;
  media: Media;
  luckyDrawDateRange: DateRange;
  winnerAnnouncementDate: string;
  maxWinners: number;
  priceDistributionDateRange: DateRange;
  prizes: Prize[];
  selectionType: "random" | "specific";
  isDeleted: boolean;
  status: "active" | "pending" | "cancelled" | "completed";
  analytics: Analytics;
  staffdetails?: any; // Avoiding strict type for now as StaffSchema wasn't provided
  createdAt?: string;
  updatedAt?: string;
}

export interface Winner {
  _id: string;
  luckyDrawId: LuckyDraw | string; // Can be populated
  userId: string; // Ref to Customer
  giftId: any; // Ref to Gift, can be populated
  giftType: "product";
  giftValueId: string;
  wonAt: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface WinnerQueryDto {
  luckyDrawId?: string;
  userId?: string;
  giftId?: string;
  giftType?: string;
  page?: number;
  limit?: number;
}

export interface ParticipateResponse {
  luckyDrawId: string;
  userId: string;
  message: string;
}

export interface LuckyDrawState {
  winners: Winner[];
  myGifts: Winner[];
  activeLuckyDraw: LuckyDraw[] | null;
  loading: {
    winners: boolean;
    participate: boolean;
    myGifts: boolean;
    activeLuckyDraw: boolean;
  };
  error: string | null;
  success: {
    participate: boolean;
  };
  message: string | null;
  pagination: {
    page: number;
    limit: number;
    total: number; // Backend doesn't return total explicitly in findAll, assumed infinite scroll or simple list
  };
}

export const LUCKY_DRAW_ACTION_TYPES = {
  FETCH_WINNERS_START: "luckyDraw/fetchWinnersStart",
  FETCH_WINNERS_BY_LUCKY_DRAW_START: "luckyDraw/fetchWinnersByLuckyDrawStart",
  PARTICIPATE_IN_LUCKY_DRAW_START: "luckyDraw/participateInLuckyDrawStart",
  FETCH_MY_GIFTS_START: "luckyDraw/fetchMyGiftsStart",
  FETCH_ACTIVE_LUCKY_DRAW_START: "luckyDraw/fetchActiveLuckyDrawStart",
};
